export interface Recommendations {
  "Score/Label To Display": string;
  "About the Score & Risk": string;
  "How is the risk for disease calculated?": string;
  Disclaimer: string;
  "Risk Factors": string[];
  Mitigation_Strategies_Heading: string[];
}

export interface Question {
  question_id: string;
  question_type: string;
  question_text: string;
  question_subcontent: string;
  is_sub_question: boolean;
  dependent_question_id: string;
  dependent_question_action: string;
  dependent_question_value: string[];
  question_values: string[];
  selected_ans: number[];
  answerIndex?: number | string;
}

export interface QuestionResponses {
  question_id: string;
  response_value: any;
}

export interface VikritiRecommendations {
  all_unique_labels: string;
  vikruti_type: string;
  prakriti_type: string;
  recommendation_type: string;
  recommendations: string[];
}

export interface Score {
  label: string;
  max_score: number;
  questions: Question[];
  score: number;
  recommendations: Recommendations;
  question_responses: QuestionResponses[];
  score_label: string;
  vikrititRecomm?: VikritiRecommendations;
}

export interface HealthScoreItem {
  score: Score;
  title: string;
}
export interface HealthScoreDetails {
  name?: string;
  recommendations: HealthScoreItem[];
}

export interface PageDetails {
  client: string;
  user_id: string;
  weight_in_kg: number;
  height_in_cms: number;
  waist_circumference_in_cms: number;
  diseases: string[];
  place_of_birth: string;
  time_of_birth: string;
}

export interface DiseaseDetail {
  risk_name: string;
  about?: string[];
  ["Risk Factors"]?: string[];
  recommendations?: string[][];
  image_url?: string;
}

export interface FilledScore {
  title: string;
  isFilled: boolean;
}

export interface ClinicCreateUser {
  user_id: string;
  client: string;
}
export interface UploadReport {
  user_id: string | null;
  client: string | null;
  image_name: string | null;
  image_type: string | null;
  image_blob: Blob | string | null;
}
export interface BasicViatls {
  height_in_cms: number | null;
  weight_in_kg: number | null;
  waist_circumference_in_cms: number | null;
}

export interface BasicDetails {
  name: string | null;
  age: number | null;
  gender: string | null;
  marital_status: string | null;
  current_address: string | null;
  alternate_phn_number: string | null;
  email: string | null;
}

export interface UserDetails {
  phone_number: string | null;
  email: string | null;
}

export interface BirthDetails {
  date: string | null;
  time: string | null;
  place: string | null;
  time_of_birth: string | null;
}
export interface Upload {
  Report: UploadReport[] | null;
  Tongue: UploadReport[] | null;
  Prescription: UploadReport[] | null;
}

export interface ClinincInitialPage {
  DxAi_1: number[] | null;
  DxAi_2: number[] | null;
  DxAi_3: number[] | null;
  DxAi_4: number[] | null;
  DxAi_5: number[] | null;
  DxAi_6: number[] | null;
  DxAi_7: number[] | null;
  DxAi_8: number[] | null;
  DxAi_9: number[] | null;
  DxAi_10: number[] | null;
  "Medical History1": number[] | null;
  "Medical History2": number[] | null;
  "Family History": number[] | null;
  "Chief Complaints": string | null;
  "Birth Details": BirthDetails | null;
  "Basic Vitals": BasicViatls | null;
  "Basic Details": BasicDetails | null;
  userDetail: UserDetails | null;
  Symptoms: string | null;
  Upload: Upload | null;
  user_id: string | null;
  client: string | null;
}

export interface ClinicErrorState {
  DxAi_1: string | null;
  DxAi_2: string | null;
  DxAi_3: string | null;
  DxAi_4: string | null;
  DxAi_5: string | null;
  DxAi_6: string | null;
  DxAi_7: string | null;
  DxAi_8: string | null;
  DxAi_9: string | null;
  DxAi_10: string | null;
  "Medical History1": string | null;
  "Medical History2": string | null;
  "Family History": string | null;
  "Chief Complaints": string | null;
  "Birth Details": {
    date: string | null;
    time: string | null;
    place: string | null;
    time_of_birth: string | null;
  };
  "Basic Vitals": {
    height_in_cms: string | null;
    weight_in_kg: string | null;
    waist_circumference_in_cms: string | null;
  };
  "Basic Details": {
    name: string | null;
    age: string | null;
    gender: string | null;
    marital_status: string | null;
    current_address: string | null;
    alternate_phn_number: string | null;
  };
  userDetail: {
    phone_number: string | null;
    email: string | null;
  };
  Symptoms: string | null;
  Upload: {
    Report: string | null;
    Tongue: string | null;
    Prescription: string | null;
  };
  user_id: string | null;
  client: string | null;
}

export interface ScoreQuestion {
  id: number;
  attributes: {
    question_id: string;
    question_text: string;
    question_description: string;
    option_type: string;
    is_sub_question: boolean | null;
    question_subcontent: string;
    question_values: string[];
    sub_points: any;
    createdAt: string;
    updatedAt: string;
    publishedAt: string;
    score_name: string;
    dependent_question_id: string;
    dependent_question_value: string;
    dependent_question_action: string;
    dosha: any;
  };
}

export interface ResponseInfo {
  question_id: string;
  response_value: any;
  response_actual_value: any;
  createdAt: string;
}

export interface PaginationMeta {
  pagination: {
    page: number;
    pageSize: number;
    pageCount: number;
    total: number;
  };
}

export interface ResponseData {
  id: number;
  attributes: {
    createdAt: string;
    response: string;
    user_id: string;
    updatedAt: string;
    publishedAt: string;
    scores_questionnaire: {
      data: ScoreQuestion;
    };
  };
}

export interface ResponsesApiResult {
  data: ResponseData[];
  meta: PaginationMeta;
}

// New app redirection state interface
export interface AppRedirectionState {
  shouldRedirectOnBasicDetails: boolean;
  shouldRedirectOnSymptoms: boolean;
  shouldRedirectOnHealthHistory: boolean;
  shouldRedirectOnDashboard: boolean;
}

export interface Medicine {
  id: number;
  name: string;
  dosage: string;
  frequency: string;
  instruction: string;
  type: string;
  createdAt: string;
  updatedAt: string;
  PrescriptionId: number;
}

export interface Prescription {
  id: number;
  nextFollowup: string;
  foodToAvoid: string;
  foodToEat: string;
  createdAt: string;
  updatedAt: string;
  CaseId: number;
  Medicines: Medicine[];
}

export interface RedirectRouteResponse {
  route: string;
  data?: {
    userDetails?: any;
    userSymptoms?: any;
    healthHistory?: any;
  };
}

export interface PaginationMeta {
  page: number;
  pageSize: number;
  pageCount: number;
  total: number;
}

export interface ApiResponse<T> {
  data: T[];
  meta: {
    pagination: PaginationMeta;
  };
}

export interface UserSymptomHistory {
  id: number;
  attributes: {
    createdAt: string;
    updatedAt: string;
    user_id: string;
    symptoms: {
      data: Array<{
        id: number;
        attributes: {
          name: string;
          createdAt: string;
          updatedAt: string;
        };
      }>;
    };
  };
}

export interface ScoreQuestionResponse {
  id: number;
  attributes: {
    createdAt: string;
    response: string;
    user_id: string;
    updatedAt: string;
    publishedAt: string;
    scores_questionnaire: {
      data: {
        id: number;
        attributes: any;
      };
    };
  };
}

export interface UserReportDetail {
  id: number;
  attributes: {
    weight_in_kg: number;
    height_in_cms: number;
    waist_circumference_in_cms: number;
    gender: string;
    user_id: string;
    client: string;
    createdAt: string;
    updatedAt: string;
    // ... other attributes
  };
}

export interface ImageAnalysisStore {
  id: number;
  attributes: {
    createdAt: string;
    updatedAt: string;
    image_description: string;
    media_type: string;
    analysis_type: string;
    publishedAt: string;
    is_visible: boolean | null;
    user_report_individual_detail: any;
    media: any;
  };
}

export interface NandiBloodReportReading {
  id: number;
  attributes: {
    user_id: string;
    parameter_name: string;
    parameter_value: string;
    parameter_limit: string | null;
    parameter_reference_range: string;
    date_of_report: string;
    createdAt: string;
    updatedAt: string;
    publishedAt: string;
  };
}

export interface UnitOption {
  value: string;
  label: string;
  conversionFactor: number; // Factor to convert TO this unit FROM base unit
}

// Height unit definitions (base unit: cm)
export const HEIGHT_UNITS: UnitOption[] = [
  { value: "cm", label: "cm", conversionFactor: 1 },
  { value: "ft_in", label: "ft.in", conversionFactor: 1 }, // Special handling for feet/inches
];

// Waist circumference unit definitions (base unit: cm)
export const WAIST_UNITS: UnitOption[] = [
  { value: "cm", label: "cm", conversionFactor: 1 },
  { value: "inches", label: "inches", conversionFactor: 0.393701 }, // 1 cm = 0.393701 inches
];

export interface QuestionnaireAttributes {
  currentComponent?: string;
  currentComponentisVisited?: boolean;
  currentComponentClassName?: string;
  currentComponentCompletionStatus?: boolean;
  isSkipableCureentCompoennt?: boolean;
  content: string;
  title?: string;
  disableBeacon?: boolean;
  placement?: "top" | "bottom" | "left" | "right" | "auto";
}


// Type definitions based on your actual fetchAppointments response
export interface FetchedAppointmentData {
  CaseId: number;
  id: number;
  doctorName: string;
  appointmentLink: string;
  rawAppointmentDate: number;
  rawStartTime: number;
  rawEndTime: number;
  appointmentType: string;
  consultationFee: number;
  consultationFeeOffline: number | null;
  appointmentDetails: {
    appointmentId: number;
    appointmentDate: string; // Already formatted by epochToISTDate
    startTime: string; // Already formatted by epochToIST
    endTime: string; // Already formatted by epochToIST
    appointmentDateRaw: number;
    startTimeRaw: number;
    endTimeRaw: number;
    appointmentLink: string;
    consultationFee: number;
    consultationFeeOffline: number | null;
  };
  patientName: string;
  patientDetails: {
    patientId: string;
    patientMobileNo: string;
    patientGender: string;
  };
  imageUrl: string | null;
}

export interface TransformedAppointmentData {
  CaseId: number;
  doctorName: string;
  appointmentDetails: {
    appointmentId: number;
    appointmentDate: number;
    startTime: number;
    endTime: number;
    appointmentType: string;
    appointmentLink: string;
    consultationFee: number;
    consultationFeeOffline: number | null;
  };
}